import React from 'react';
import './ConfirmBrand.less';
import { getBrandImageUrl, getFlagImageUrl } from '../../utils/constants';

import backgroundImage from '../../images/cabin-blue-create-account-page.svg';
import ConfirmBrandButtonHolder from '../ButtonHolder/ConfirmBrandButtonHolder';
import AlertBox from "../Alert/Alert";
import { ButtonPrimary } from '@homeaway/react-buttons';

export default class ConfirmBrand extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.triggerEdapPageViewAction();
    }

    getConfirmBrandContent(isPPM, translations, primarySite, getYesButtonClick, getNoButtonClick, brandImage, flagImage) {
        return (
            <div className="page-content">
                <div className="pangel-head">
                    <h1 className="header">{isPPM? translations['ipmob.multiple_accounts.heading'] : translations['ipmob.confirm_brand.heading']}</h1>
                </div>
                <div className="confirm-brand-pg-description-1">
                    {/* eslint-disable-next-line react/no-danger */}
                    <p dangerouslySetInnerHTML={{ __html: isPPM? translations['ipmob.confirm_brand.description_1'] : translations['ipmob.confirm_brand.description_3']}} />
                </div>
                <div className="confirm-brand-pg-description-2">
                    {/* eslint-disable-next-line react/no-danger */}
                    <p dangerouslySetInnerHTML={{ __html: isPPM? translations['ipmob.confirm_brand.description_2'] : translations['ipmob.confirm_brand.description_4']}} />
                </div>
                <div className="confirm-brand-pg-content">
                    <ConfirmBrandButtonHolder
                        enableContinueButton={false}
                        handleContinueButtonClick={null}
                        translations={translations}
                        continueButtonId='confirmBrandButton'
                        data={primarySite}
                        brandImage={brandImage}
                        flagImage={flagImage}
                    />
                    <div className="confirm-brand-pg-buttons">
                        <ButtonPrimary
                            className="confirm-brand-pg-change"
                            label={translations['ipmob.confirm_brand.button_text_1']}
                            type="submit"
                            value="Submit"
                            id={'NoThisIsNotCorrectButton'}
                            onClick={event => getNoButtonClick(event)}
                        />
                        <ButtonPrimary
                            label={translations['ipmob.confirm_brand.button_text_2']}
                            type="submit"
                            value="Submit"
                            id={'YesThisIsCorrectButton'}
                            onClick={event => getYesButtonClick(event, primarySite)}
                        />
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const {
            translations,
            primarySite,
            serviceError,
            isPPM,
            handleYesButtonClick,
            handleNoButtonClick,
            handleAlertDismiss
        } = this.props;

        const brandImage = getBrandImageUrl(primarySite.name);
        const flagImage = getFlagImageUrl(primarySite.name);

        return (
            <div className="confirm-brand-pg">
                <div className="confirm-brand-pg-wrapper container">
                    {
                        (serviceError)
                            ? <div className="alert-panel">
                                <AlertBox
                                    messageKey={serviceError}
                                    translations={translations}
                                    handleAlertDismiss={handleAlertDismiss}
                                    size={'sm'}
                                />
                            </div>
                            : null
                    }
                    <img className="confirm-brand-pg-bg-img" src={backgroundImage()} />
                    {this.getConfirmBrandContent(isPPM, translations, primarySite, handleYesButtonClick, handleNoButtonClick, brandImage, flagImage)}
                </div>
            </div>
        );
    }

}
